import { render } from "./SubjectList.component.vue?vue&type=template&id=30d2fa84&scoped=true&ts=true"
import script from "./SubjectList.component.vue?vue&type=script&lang=ts"
export * from "./SubjectList.component.vue?vue&type=script&lang=ts"

import "./SubjectList.component.vue?vue&type=style&index=0&id=30d2fa84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d2fa84"]])

export default __exports__